module.exports = __webpack_public_path__ + "img/to_top.ed4b9c53.png";